import { Grid, Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import addLeads from '../../../api/SendEmails/addLeads.api';
import CustomButton from '../../layout/customButton/CustomButton';
import Modal from '../../layout/modal/Modal';
import LeadsTable from './LeadsTable';
import LeadsForm from '../../sendEmail/forms/LeadsForm';
import styles from '../Deals.module.scss';
import getAllSalesAgents from '../../../api/SendEmails/getAllSalesAgents.api';
import {
	getLeadById,
	deleteLeadById,
	clearLeadByID,
} from '../../../redux/deals/action';
import { openModal, closeModal } from '../../../redux/modals/action';

import Addleadsmodal from './AddLeadsModal/AddLeadsModal';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../redux/confirmations/actions';
import ConfirmationComponent from '../../confirmation/ConfirmationComponent';
import { getPurchasers } from '../../../redux/purchasers/actions';

import Loading from '../../layout/loading/Loading';

const LeadsSection = ({
	leads,
	user,
	search,
	modals,
	openModal,
	closeModal,
	getLeadById,
	deleteLeadById,
	setConfirmation,
	leadById,
	closeConfirmation,
	confirmation,
	getPurchasers,
	clearLeadByID,
	loading,
}) => {
	const [salesAgents, setSalesAgents] = useState();
	const [anchorEl, setAnchorEl] = useState(null);
	const [formData, setFormData] = useState({
		subject: '',
		clientFName: '',
		clientEmail: '',
		clientPhoneNumber: '',
		city: '',
		postalCode: '',
	});
	const [editKey, setEditKey] = useState();
	const {
		subject,
		clientFName,
		clientEmail,
		clientPhoneNumber,
		city,
		postalCode,
	} = formData;
	const [filteredLeads, setFilteredLeads] = useState();

	var buttonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleDeleteConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	const handleLeads = () => {
		addLeads(user.uid, clientFName, clientEmail, clientPhoneNumber);
		closeModal('addLeads');
	};

	useEffect(() => {
		//getPurchasers();
	}, []);

	useEffect(() => {
		console.log('anchorEL', anchorEl);
	}, [anchorEl]);

	const handleAddLead = () => {
		clearLeadByID();
		setEditKey();
		openModal('addLeads');
		getAllSalesAgents().then((returned) => {
			setSalesAgents(returned);
		});
	};

	const handleEditLead = (e, key) => {
		getLeadById(key);
		setEditKey(key);
		openModal('addLeads');
		setAnchorEl(null);
	};

	const handleDeleteLead = async (e, key) => {
		console.log('deleteLead');
		await setConfirmation('deleteLead');
		setEditKey(key);
		setAnchorEl(null);
	};

	const handleCloseConfirmation = () => {
		closeConfirmation('deleteLead');
	};

	const handleDeleteConfirmation = () => {
		closeConfirmation();
		editKey && deleteLeadById(editKey);
	};

	return (
		<>
			<Grid item xl={9} lg={9} xs={12}>
				<Paper className={styles.leads_table}>
					<div className={styles.table_header_group}>
						<h2 className={styles.table_title}>
							Leads ({filteredLeads?.length})
						</h2>

						<CustomButton
							onClick={() => handleAddLead()}
							width={166}
							height={42}
						>
							Add Lead
						</CustomButton>
					</div>

					<LeadsTable
						leads={leads}
						search={search}
						handleEditLead={handleEditLead}
						handleDeleteLead={handleDeleteLead}
						anchorEl={anchorEl}
						setAnchorEl={setAnchorEl}
						filteredLeads={filteredLeads}
						setFilteredLeads={setFilteredLeads}
					/>
				</Paper>
			</Grid>

			<Addleadsmodal
				openModal={modals.addLeads}
				handleLeads={handleLeads}
				leadById={leadById}
				editKey={editKey}
			/>

			{/* //open, handleClose, title, dialogContent, buttonList  */}

			<ConfirmationComponent
				open={confirmation?.deleteLead}
				handleClose={handleCloseConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	leads: state.leads.leads,
	leadById: state.leads.leadById || state.purchasers.purchaserById,
	loading: state.leads.loading,
	user: state.signIn,
	modals: state.leads.modals,
	confirmation: state.confirmation,
});

export default connect(mapStateToProps, {
	openModal,
	closeModal,
	getLeadById,
	deleteLeadById,
	setConfirmation,
	closeConfirmation,
	getPurchasers,
	clearLeadByID,
})(LeadsSection);
